/**
 * Created by anatoly on 20.06.2025
 */

const FlatMerge2BaseTutorial = function () {
    return new TutorialScenario(TutorialScenario.BASIC_TUTORIAL_NAME, {
        manual: true,
        isAvailable: function () {
            return Merge2.current && Merge2.current.orderManager.index === 0;
        },

        listSteps: FlatMerge2BaseTutorial.listSteps
    });
};

FlatMerge2BaseTutorial.listSteps = function () {
    const steps = [];

    FlatMerge2BaseTutorial.STEPS.forEach((step) => {
        if (step.dialogue && cleverapps.meta.getSelectedLocation().isFirstFix()) {
            steps.push(Merge2TutorialHelper.createDialogueStep(step));
        }

        if (step.roomIntro) {
            const roomView = cleverapps.Scenes.GetSceneComponent(Merge2SceneComponent).roomView;
            for (let index = 0; roomView.isFreeRepair && roomView.isFreeRepair(index); index++) {
                steps.push(Merge2TutorialHelper.createFreeFixStep());
            }
        }

        if (step.animation) {
            steps.push(Merge2TutorialHelper.createAnimationStep(step));
        }

        if (step.switch) {
            steps.push(FlatMerge2BaseTutorial.createShowSwitchButtonStep());
            steps.push(Merge2TutorialHelper.createSwitchStep(step));
        }
        if (step.minimal) {
            steps.push(Merge2TutorialHelper.createMinimalDialogueStep(step));
        }
        if (step.merge) {
            steps.push(Merge2TutorialHelper.createMergeStep(step));
        }
        if (step.clickUnit) {
            steps.push(Merge2TutorialHelper.createClickUnitStep(step));
        }
        if (step.recipe) {
            steps.push(Merge2TutorialHelper.createReplaceOrderStep(step));
        }
        if (step.order) {
            steps.push(Merge2TutorialHelper.createClickRowStep({
                rowId: step.order.id,
                finishEvent: "onCustomerExchange",
                force: {
                    disableFallbackTimeout: true,
                    text: step.text,
                    gravitate: MinimalDialogue.GRAVITATE.BOTTOM
                }
            }));
        }
    });

    if (typeof StartAnimation !== "undefined" && StartAnimation.hero) {
        steps.push(new TutorialStep({
            onStart: function () {
                StartAnimation.hero.removeFromParent();
                delete StartAnimation.hero;
                this.finish();
            },

            onFinish: function () {
                Merge2.current.counter.trigger();
            }
        }));
    }

    return steps;
};

FlatMerge2BaseTutorial.createShowSwitchButtonStep = function () {
    return new TutorialStep({
        onStart: function () {
            cleverapps.Scenes.GetSceneComponent(Merge2SceneComponent).showSwitchButton();
            cleverapps.timeouts.setTimeout(this.finish.bind(this), 400);
        },

        onFinish: function () {
            Merge2.current.counter.trigger();
        }
    });
};

FlatMerge2BaseTutorial.STEPS = [
    typeof StartAnimation !== "undefined" ? {
        animation: StartAnimation
    } : {
        dialogue: true,
        dialogueConfig: bundles.baseTutorial.jsons.dialogues_json,
        imageBundle: "baseTutorial"
    },
    {
        roomIntro: true
    },
    {
        customerIndex: 0,
        recipe: {
            ingredients: [{ unit: { code: "a", stage: 2 }, amount: 1 }]
        }
    },
    {
        switch: true,
        mode: Merge2.MODE_GAME,
        text: "Merge2.BaseTutorialSwitch",
        finger: true
    },
    {
        minimal: true,
        position: Merge2TutorialHelper.getPositionAboveMap,
        text: "Merge2.BaseTutorialBoard"
    },
    {
        merge: true,
        position: Merge2TutorialHelper.getPositionAboveMap,
        unit: { code: "AB", stage: 0 },
        text: "Merge2.BaseTutorial0",
        highlightedCells: true
    },
    {
        merge: true,
        position: Merge2TutorialHelper.getPositionAboveMap,
        unit: { code: "AB", stage: 1 },
        text: "Merge2.BaseTutorial1",
        highlightedCells: true
    },
    {
        merge: true,
        position: Merge2TutorialHelper.getPositionAboveMap,
        unit: { code: "AB", stage: 2 },
        highlightedCells: true
    },
    {
        clickUnit: true,
        position: Merge2TutorialHelper.getPositionAboveMap,
        unit: { code: "AB", stage: 3 },
        count: 2,
        finishEvent: "onUnitSpawned",
        finishFilter: () => true,
        text: "Merge2.BaseTutorial2",
        highlightedCells: [{ x: 3, y: 1 }, { x: 3, y: 2 }, { x: 3, y: 3 },
            { x: 4, y: 1 }, { x: 4, y: 2 }, { x: 4, y: 3 },
            { x: 5, y: 1 }, { x: 5, y: 2 }, { x: 5, y: 3 }
        ]
    },
    {
        merge: true,
        position: Merge2TutorialHelper.getPositionAboveMap,
        unit: { code: "a", stage: 0 },
        noGroundedFirst: true
    },
    {
        merge: true,
        position: Merge2TutorialHelper.getPositionAboveMap,
        unit: { code: "a", stage: 1 }
    },
    {
        order: { id: 0 },
        text: "Merge2.BaseTutorial3"
    },
    {
        customerIndex: 0,
        recipe: {
            ingredients: [{ unit: { code: "a", stage: 7 }, amount: 1 }]
        }
    }
];
